document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#pms-kalibrierung');

    if (form) {
        const rowContainer = form.querySelector('.form-rows');
        const addButton = form.querySelectorAll('.add');
        const deleteButton = form.querySelectorAll('.delete');
        const rows = rowContainer.querySelectorAll('.form-row');
        const lastRow = rows[rows.length - 1];
        const rowId = lastRow.querySelector('input').getAttribute('id');
        const select = form.querySelectorAll('.auswahl');
        const hinweisHandmessmittel = form.querySelector('.handmessmittel-info');
        let index = rows.length;

        //Index auf die letzte Zeile im Formular setzen
        const r = /\d+/g;
        const match = rowId.match(r)

        if (match !== 0) {
            index = parseInt(match[0]) + 1;
        }

        //Zeilennummern in "visuelle Zeilnummern" ersetzen
        const errorItems = document.querySelectorAll('.errorsPms ul li');
        // Erstelle ein Mapping von Feld-ID-Zahl → Index
        const rowIndexMap = Array.from(rows).reduce((map, row, index) => {
            const input = row.querySelector('input');
            if (!input) return map;
            //Holt sich die Zahl aus der ID
            const match = input.id.match(r);
            if (match) {
                // Wir speichern die Zuordnung: Tatsächliche Zeilennummer
                // (z.B. pms_kalibrierung[rows][7][auswahl]) : gewünschte Zeilennummer
                map[parseInt(match[0])] = index + 1;
            }
            return map;
        }, {});

        // Iteriere einmal über die Error-Items
        errorItems.forEach((li) => {
            //Holt sich die Zahl aus der Fehlermeldung
            const match = li.innerText.match(r);

            if (match) {
                //Ursprüngliche Zeilennummern
                const originalLine = parseInt(match[0]);

                //Gibt true zurück, wenn die Eigenschaft in der map vorhanden ist
                if (rowIndexMap.hasOwnProperty(originalLine - 1)) {
                    //Ersetzen durch die neuen Zeilnummern
                    li.innerText = li.innerText.replace(/Zeile \d+/, 'Zeile ' + rowIndexMap[originalLine - 1]);
                }
            }
        });

        const handleHandmessmittelInfo = function (){
            const auswahlFelder = document.querySelectorAll('.auswahl');
            hinweisHandmessmittel.classList.remove('show');

            auswahlFelder.forEach(
                (el) => {

                    if(el.value === "Handmessmittel"){
                        hinweisHandmessmittel.classList.add('show');
                    }

                }
            )

        }

        //Funktion: Letzte Zeile hinzufügen
        const addRow = function (e) {
            e.preventDefault();
            const prototype = rowContainer.dataset.prototype;

            let newForm = prototype.replace(/__name__/g, index);
            rowContainer.insertAdjacentHTML('beforeend', newForm);
            index++;
        }

        //Funktion: Letzte Zeile löschen
        const deleteRow = function (e) {
            e.preventDefault();
            const rows = rowContainer.querySelectorAll(".gridRow");

            let lastRow = rows[rows.length - 1];
            if (rows.length > 1) {
                lastRow.remove();
                index--;
            }
        }

        //Funktion: Zurücksetzen der Felder
        const resetField = function (field) {
            if (!field) return;

            const fieldType = field.querySelectorAll('input, select');

            // entferne die Anzeige-Klasse am Parent (falls vorhanden)
            if (field.parentNode && field.parentNode.classList) {
                field.parentNode.classList.remove('show');
            }

            // Input text: leeren
            if (fieldType[0] && fieldType[0].type === 'text') {
                fieldType[0].value = '';
            }

            // Select: auf ersten Eintrag setzen
            if (fieldType[0] && fieldType[0].tagName === 'SELECT') {
                fieldType[0].selectedIndex = 0;
            }

            // Checkboxen / Radio: abwählen
            if (fieldType[0] && (fieldType[0].type === 'checkbox' || fieldType[0].type === 'radio')) {
                // Aber nicht PKW/Rolle, hier wieder auf die erste Auswahl zurücksetzen
                if (!field.querySelector('div').classList.contains('pkw-roller')) {
                    //Sollte es sich nicht um PKW/Rolle handeln
                    //werden alle Radiobuttons zurückgesetzt
                    fieldType.forEach((el) => el.checked = false);
                } else {
                    //Bei PKW/Rolle das erste Feld wieder inital selektieren
                    fieldType[0].checked = true;
                }
            }

        }

        //Funktion: Felder abhängig vom Wert im Auswahlmenü anzeigen
        const showField = function (target, isInit) {

            const parent = target.closest('.form-row');
            const fields = parent.querySelectorAll('.depended-field>div');
            let value = target.value;

            fields.forEach(
                (field) => {
                    const showon = JSON.parse(field.dataset.showon.replace(/'/g, '"'));

                    if (!isInit) {
                        resetField(field);
                    }

                    if (!!showon) {
                        if (showon.includes(value) && !!value) {
                            field.parentNode.classList.add('show');
                        }
                    }
                }
            )

        }

        //Zeilenbasierendes löschen
        rowContainer.addEventListener('click', function (event) {

            if (event.target.classList.contains('delete-row')) {
                event.preventDefault();
                event.target.closest('.form-row').remove();
                //Hinweistext Handmessmittel einblenden wenn diese ausgewählt wurden
                handleHandmessmittelInfo();
            }
        });
        //Zeile unten hinzufügen
        addButton.forEach(
            (el) => el.addEventListener('click', addRow)
        )
        //letzte Zeile löschen
        deleteButton.forEach(
            (el) => {
                el.addEventListener('click', deleteRow);
                //Hinweistext Handmessmittel einblenden wenn diese ausgewählt wurden
                handleHandmessmittelInfo();
            }
        )

        //Felder werden abhängig vom Auswahlmenü Prüfmittel angezeigt
        //Hinweistext wird abhängig von "Handmessmittel" angezeigt
        form.addEventListener('change', function (event) {
            //event.preventDefault();
            const target = event.target;

            // Auswahl der Prüfmittel
            if (target.classList.contains('auswahl')) {

                showField(target, false);
            }
            //Hinweistext Handmessmittel einblenden wenn diese ausgewählt wurden
            handleHandmessmittelInfo();
        });

        //Felder werden nach Abschicken des Formulars bzw. initial wieder eingeblendet
        select.forEach(
            (el) => showField(el, true)
        )

    }
});